import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  Card,
  Chip,
  Divider,
  Grid,
  Menu,
  MenuItem,
  Paper,
  alpha,
  styled,
  useMediaQuery,
} from '@mui/material';
import avatar3 from 'assets/avatar-3.png';
import img1 from 'assets/img1.png';
import img2 from 'assets/img2.jpg';
import long from 'assets/long.png';
import BookmarkAlert from 'components/alerts/BookmarkAlert';
import AppAvatar from 'components/avatars/AppAvatar';
import FlexBox from 'components/flexbox/FlexBox';
import FlexRowAlign from 'components/flexbox/FlexRowAlign';
import ImageViewer from 'components/ImageViewer';
import { H2, H6, H7, Small, TableContent } from 'components/Typography';
import {
  AlignRight,
  ArrowLeft,
  Bookmark,
  Download,
  Edit,
  Folder,
  Home,
  Share2Icon,
  Siren,
  ThumbsUp,
} from 'lucide-react';
import React, { useState } from 'react';
import { MessageCircle, Trash2 } from 'react-feather';
import { useNavigate } from 'react-router-dom';
import Comments from '../../../page-sections/callmetellme/Comments';
import AIReplyCard from './AIReplyCard';
import ReplyCard from './ReplyCard';

const description = `안녕하세요! 요즌 가장  재밌게 플레이하고 있는 땡땡마법사 완전 제 취향이라 너무 재밌내요ㅎㅎ

재밌게 플레이하다보니 항상 체력이 모자른데요 ㅠㅠ

편지로 보내주는 체력들이 참 쏠쏠합니다!


아무튼 본론으로 들어가서
체력이 충전까지 얼마나 걸리는지 시간 표기가 되면 너무 좋을거 같아요.

1개 충전당 걸리는 시간이나 아니면 완충까지 걸리는 시간 등을 표기해주는 기능이 추가되면 좋을거 같아 건의드립니다.`;

const replyData = [
  {
    writer: '이대현 세무사 답변',
    date: '2023.12.28',
    reply: `안녕하세요 로원파트너스 이대현세무사입니다.

    해당 업종에 대하여 확인이 필요하신 것 같습니다.724002 업종코드는 정보통신업으로서 청년 창업중소기업 세액감면이 되는 업종코드에 해당합니다.

    실제 영위하는 사업의 내용이 724002 업종코드의 내용과 일치하고 나이요건, 최초 창업요건을 충족하신 경우이면서 해당 업종으로 사업자를 내신 경우라면 감면이 가능할 것으로 보입니다.

    문의주신 내용만으로 판단한 것으로 실제 감면여부는 담당 세무사님께 적용 여부를 확인받아보시기 바랍니다.`,
  },
];

const aiReplyData = [
  {
    writer: '슈가 AI',
    avatar: '/static/avatar/robot.png',
    reply: `안녕하세요 로원파트너스 이대현세무사입니다.

    해당 업종에 대하여 확인이 필요하신 것 같습니다.724002 업종코드는 정보통신업으로서 청년 창업중소기업 세액감면이 되는 업종코드에 해당합니다.

    실제 영위하는 사업의 내용이 724002 업종코드의 내용과 일치하고 나이요건, 최초 창업요건을 충족하신 경우이면서 해당 업종으로 사업자를 내신 경우라면 감면이 가능할 것으로 보입니다.

    문의주신 내용만으로 판단한 것으로 실제 감면여부는 담당 세무사님께 적용 여부를 확인받아보시기 바랍니다.`,
  },
];

const commentData = [
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: true,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment:
      '긴 댓글 예시입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다 긴 댓글입니다',
    delete: false,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: false,
  },
  {
    writer: '라운지 초심자',
    views: 238,
    date: '2023.12.28',
    comment: '체력 1당 10분입니다',
    delete: false,
  },
];

const StyledCard = styled(Card)(({ theme, isTablet }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '2rem 2rem 2rem 2rem',
  justifyContent: 'space-between',
  flexDirection: 'column',
  border: 'none',
  borderRadius: isTablet ? '0px' : '24px',
  boxShadow: isTablet ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.08)',
  borderBottom: isTablet ? '1px solid #E1E1E1' : 'none',
  [theme.breakpoints.down('sm')]: {
    padding: '1rem 0rem 1rem 0rem',
    textAlign: 'center',
    marginBottom: '1rem',
  },
}));

const getChipStyles = type => {
  if (type === '일정') {
    return {
      color: '#FF9800', // Orange color
      backgroundColor: alpha('#FFF9C4', 0.7), // Light yellow background
    };
  }

  if (type === '태그') {
    return {
      color: '#636469',
      backgroundColor: alpha('#636469', 0.1),
    };
  }

  return {
    color: '#4E2BF4',
    backgroundColor: alpha('#4E2BF4', 0.1),
  };
};

export default function CommunityDetailSection({ isModal }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const [selectValue, setSelectValue] = useState('등록순');
  const [isLiked, setIsLiked] = useState(false);
  const [isDisliked, setIsDisliked] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [imageViewerOpen, setImageViewerOpen] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const postImages = [
    {
      largeURL: img1,
      thumbnailURL: img1,
    },
    {
      largeURL: img2,
      thumbnailURL: img2,
    },
    {
      largeURL: long,
      thumbnailURL: long,
    },
    {
      largeURL: '/static/emoji/shine.png',
      thumbnailURL: '/static/emoji/shine.png',
    },
  ];
  const handleChange = event => setSelectValue(event.target.value);
  const handleLike = () => {
    if (isLiked) {
      setIsLiked(false);
      setIsDisliked(false);
    } else {
      setIsLiked(true);
      setIsDisliked(false);
    }
  };
  const handleDislike = () => {
    if (isDisliked) {
      setIsDisliked(false);
      setIsLiked(false);
    } else {
      setIsDisliked(true);
      setIsLiked(false);
    }
  };
  const handleBookmark = () => {
    setIsBookmarked(!isBookmarked);
    setShowAlert(true);
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setShowAlert(false);
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const iconData = [
    {
      Icon: ThumbsUp,
      title: '좋아요',
      color: 'grey900',
      value: '28',
      onClick: handleLike,
      isActive: isLiked,
    },
    { Icon: MessageCircle, title: '댓글', color: 'grey900', value: '9' },
    { Icon: Bookmark, title: '북마크', color: 'grey900', value: '21' },
  ];

  const ButtonStyle = {
    height: '32px',
    fontSize: 14,
    color: 'primary.grey2',
    borderRadius: 2,
    fontWeight: 500,
    backgroundColor: '#ffffff',
    padding: '0 1rem',
  };

  const handleMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <FlexBox flexDirection="column" width="100%" gap={isMobile ? '5px' : 3}>
      <StyledCard isTablet={isTablet}>
        <FlexRowAlign mb={2} px={isMobile ? 2 : 0} sx={{ width: '100%' }}>
          <FlexRowAlign
            width="100%"
            justifyContent="flex-start"
            alignItems="center"
            gap={1}
            sx={{ cursor: 'pointer' }}
            onClick={() => navigate(-1)}
          >
            <ArrowLeft size={20} color={theme.palette.primary.mainBlue} />
            <H6 sx={{ color: 'primary.mainBlue', fontWeight: 600 }}>
              게시판 제목
            </H6>
          </FlexRowAlign>

          {isMobile && <Home size={20} color={theme.palette.primary.grey900} />}
        </FlexRowAlign>

        {/*  */}
        <FlexRowAlign
          mb={2}
          px={isMobile ? 2 : 0}
          sx={{ width: '100%', justifyContent: 'space-between' }}
        >
          <Chip
            label={'이야기'}
            sx={{
              height: 22,
              fontSize: 12.5,
              ...getChipStyles('이야기'),
              borderRadius: 1,
            }}
          />

          <FlexBox gap={1} justifyContent="flex-start">
            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                navigate('/naver/community/editor', {
                  state: { from: 'edit' },
                })
              }
              sx={{
                ...ButtonStyle,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: theme.palette.primary.mainBlue,
                color: '#ffffff',
                '&:hover': {
                  backgroundColor: theme.palette.primary.mainBlue,
                  color: '#ffffff',
                  borderColor: theme.palette.primary.mainBlue,
                },
              }}
            >
              글쓰기
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{
                ...ButtonStyle,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              이전
            </Button>
            <Button
              variant="outlined"
              size="small"
              sx={{
                ...ButtonStyle,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              다음
            </Button>
          </FlexBox>
        </FlexRowAlign>
        {/*  */}

        <FlexBox
          px={isMobile ? 2 : 0}
          gap={1}
          sx={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
          }}
        >
          <H2>안녕하세요 오늘도 화이팅입니다</H2>
        </FlexBox>

        <FlexBox
          mt={4}
          mb={2}
          px={isMobile ? 2 : 0}
          py={isMobile ? 1 : 0}
          flexDirection={'row'}
          justifyContent="space-between"
          alignItems="flex-start"
          width="100%"
        >
          <Grid
            mb={isMobile ? 2 : 0}
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <FlexBox
              alignItems="center"
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate('/naver/community/profile/other')}
            >
              <AppAvatar
                alt="avatar"
                src={avatar3}
                style={{ width: '42px', height: '42px' }}
              />
              <FlexBox flexDirection="column" ml={1.2}>
                <TableContent
                  sx={{
                    whiteSpace: 'nowrap',
                    color: theme.palette.primary.dark,
                  }}
                >
                  GM 보조 마법사
                </TableContent>
                <Small mb={0.5}>2023.12.28</Small>
              </FlexBox>
            </FlexBox>
          </Grid>

          <FlexRowAlign gap={1}>
            <Button
              variant="outlined"
              size="small"
              onClick={handleBookmark}
              sx={{
                minWidth: 'fit-content',
                paddingX: 1,
                color: isBookmarked
                  ? theme.palette.primary.mainBlue
                  : '#636469',
                borderColor: isBookmarked
                  ? theme.palette.primary.mainBlue
                  : 'none',
              }}
            >
              <Bookmark
                color={
                  isBookmarked ? theme.palette.primary.mainBlue : '#636469'
                }
                size={20}
              />
            </Button>

            <Button
              variant="outlined"
              size="small"
              onClick={() =>
                navigate('/dashboard/texteditor', { state: { from: 'edit' } })
              }
              sx={{
                minWidth: 'fit-content',
                paddingX: 1,
              }}
            >
              <Share2Icon size={20} />
            </Button>

            <Button
              onClick={handleMenuOpen}
              variant="outlined"
              size="small"
              sx={{
                minWidth: 'fit-content',
                paddingX: 1,
              }}
            >
              <AlignRight size={20} />
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                onClick={event => event.stopPropagation()}
                disableScrollLock={true}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <MenuItem onClick={handleMenuClose}>
                  <FlexBox alignItems="center">
                    <Edit color={theme.palette.primary.violet} size={20} />
                    <H7 ml={1}>수정</H7>
                  </FlexBox>
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  <FlexBox alignItems="center">
                    <Trash2 color={theme.palette.primary.red} size={20} />
                    <H7 ml={1}>삭제</H7>
                  </FlexBox>
                </MenuItem>
                <MenuItem onClick={handleMenuClose}>
                  <FlexBox alignItems="center">
                    <Siren color={theme.palette.primary.orange} size={20} />
                    <H7 ml={1}>신고</H7>
                  </FlexBox>
                </MenuItem>
              </Menu>
            </Button>
          </FlexRowAlign>
        </FlexBox>

        <FlexBox
          gap={1}
          px={isMobile ? 2 : 0}
          width="100%"
          justifyContent="flex-start"
        >
          <Chip
            label={'태그1'}
            sx={{
              height: 22,
              fontSize: 12.5,
              ...getChipStyles('태그'),
              borderRadius: 1,
            }}
          />
          <Chip
            label={'태그2'}
            sx={{
              height: 22,
              fontSize: 12.5,
              ...getChipStyles('태그'),
              borderRadius: 1,
            }}
          />
          <Chip
            label={'태그3'}
            sx={{
              height: 22,
              fontSize: 12.5,
              ...getChipStyles('태그'),
              borderRadius: 1,
            }}
          />
        </FlexBox>

        <Divider
          style={{
            height: '1px',
            margin: isMobile ? '20px 0rem' : '40px -2rem',
            backgroundColor: '#E1E1E1',
            width: 'calc(100% + 4rem)',
          }}
        />

        {/* Images Gallery - clicking launches PhotoSwipe lightbox */}
        <ImageViewer images={postImages} galleryID="post-gallery" />
        {/* Description */}
        <H6
          py={2}
          px={isModal && isMobile ? 4 : isMobile ? 2 : 0}
          sx={{ textAlign: 'left', width: '100%' }}
        >
          {description.split('\n').map((item, key) => (
            <React.Fragment key={key}>
              {item}
              <br />
            </React.Fragment>
          ))}
        </H6>

        <FlexBox
          px={isMobile ? 2 : 0}
          mt={4}
          gap={2}
          sx={{
            flexDirection: 'column',
            width: '100%',
            justifyContent: 'flex-start',
          }}
        >
          {[
            { name: '초창패 합격증.pdf' },
            { name: '사업자등록증명.pdf' },
            { name: '표준제무제표증명.pdf' },
          ].map((file, index) => (
            <Paper
              key={index}
              elevation={1}
              sx={{
                width: isMobile ? '100%' : '400px',
                border: '1px solid #E1E1E1',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                py: 1.5,
                px: 2,
                borderRadius: '12px',
                backgroundColor: '#ffffff',
                cursor: 'pointer',
                boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
                '&:hover': {
                  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                },
              }}
            >
              <FlexBox alignItems="center" gap={1}>
                <Folder size={20} color={theme.palette.primary.grey900} />
                <H6 sx={{ color: theme.palette.primary.grey900 }}>
                  {file.name}
                </H6>
              </FlexBox>
              <Download size={20} color={theme.palette.primary.grey900} />
            </Paper>
          ))}
        </FlexBox>

        {!isMobile && (
          <Divider
            style={{
              height: isMobile ? '5px' : '1px',
              margin: '20px 0',
              backgroundColor: '#E1E1E1',
              width: '100%',
            }}
          />
        )}

        <FlexRowAlign
          pt={isMobile ? 3 : 0}
          px={isMobile ? 2 : 0}
          sx={{
            flexDirection: isMobile ? 'column' : 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2.5,
          }}
        >
          <FlexRowAlign
            sx={{
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 2.5,
            }}
          >
            {iconData.map(
              ({ Icon, title, color, value, onClick, isActive }, index) => (
                <React.Fragment key={index}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: onClick ? 'pointer' : 'default',
                    }}
                    onClick={onClick}
                  >
                    <Icon
                      size={16}
                      color={
                        isActive
                          ? theme.palette.primary.mainBlue
                          : theme.palette.primary[color]
                      }
                      style={{ marginRight: '4px' }}
                    />
                    <H6
                      sx={{
                        fontSize: 14,
                        color: isActive
                          ? theme.palette.primary.mainBlue
                          : theme.palette.primary[color],
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {title} {value}
                    </H6>
                  </Box>
                  {index < iconData.length - 1 && (
                    <Divider
                      orientation="vertical"
                      flexItem
                      sx={{
                        height: '14px',
                        alignSelf: 'center',
                        borderColor: theme.palette.primary.grey900,
                      }}
                    />
                  )}
                </React.Fragment>
              )
            )}
          </FlexRowAlign>

          <FlexRowAlign>
            <Button
              variant="outlined"
              size="small"
              sx={{
                ...ButtonStyle,
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: 'fit-content',
              }}
            >
              <FlexRowAlign component="span" gap={1}>
                <Share2Icon size={18} sx={{ marginRight: '4px' }} />
                공유
              </FlexRowAlign>
            </Button>
          </FlexRowAlign>
        </FlexRowAlign>
      </StyledCard>

      {/* 답글 */}
      {replyData.map((item, index) => (
        <ReplyCard
          key={index}
          avatar={avatar3}
          username={item.writer}
          date={item.date}
          reply={item.reply}
        />
      ))}

      {/* AI 답글 */}
      {aiReplyData.map((item, index) => (
        <AIReplyCard
          key={index}
          avatar={item.avatar}
          reply={item.reply}
          isLiked={isLiked}
          onLike={handleLike}
          isDisliked={isDisliked}
          onDislike={handleDislike}
        />
      ))}

      <Comments commentData={commentData} />

      {/* {!isMobile && <TodayPopularPosts />} */}

      <BookmarkAlert open={showAlert} onClose={handleCloseAlert} />
    </FlexBox>
  );
}
